import { ITab, TCNRAllColumns } from "./types";

const vesselOnboardConstants = {
	feature: "@vessel/onboard",
	forms: {
		CREW: "CREW",
		DEVICE: "DEVICE",
		VESSEL: "VESSEL",
	},
};

export const localRangeManagementHeaderList = [
	{ name: "S.no" },
	{ name: "Metric" },
	{ name: "Range" },
	{ name: "Date Modified" },
	{ name: "Remarks" },
	{ name: "Actions" },
];

export const configRangeManagementHeaderList = [
	{ name: "S.no" },
	{ name: "Metric" },
	{ name: "Range" },
	{ name: "Remarks" },
	{ name: "Actions" },
];

export const RANGE_MANAGEMENT_PER_PAGE = 15;

export const vesselSubTypeMap: Record<string, string> = {
	"Container Carrier": "CONTAINER",
	"RO-RO Carrier": "PCTC",
	"Bulk Carrier": "BULK",
	"Liquefied Carrier": "LNG",
	"Chemical Carrier": "TANKER",
	"Product Carrier": "TANKER",
	"Crude Carrier": "TANKER",
};

export const cnrTabs: ITab[] = [
	{
		id: "noonReport",
		label: "Noon Report",
		path: "/noonReport",
		type: ["NOON"],
	},
	{
		id: "arrivalsDepartures",
		label: "Arrivals & Departures",
		path: "/arrivalsDepartures",
		type: ["ARRIVAL", "DEPARTURE"],
	},
	{
		id: "sofForms",
		label: "SOF Forms",
		path: "/sofForms",
		type: ["SOF"],
	},
	{
		id: "bunker",
		label: "Bunker",
		path: "/bunker",
		type: ["BUNKER"],
	},
	{
		id: "stoppages",
		label: "Stoppages",
		path: "/stoppages",
		type: ["STOPPAGE"],
	},
	{
		id: "cargo",
		label: "Cargo",
		path: "/cargo",
		type: ["CARGO"],
	},

]

// Update the version when there is a change in columns
export const CNRColumnsVersion = "1.0.2";

export const allCNRColumns: TCNRAllColumns = {
	noonReport: [
		{
			label: "From Date - To Date",
			subLabel: "Start Time (LT) - End Time (LT)",
			isDefault: true,
			ids: {
				STEAMING: "from_utc_date",
				PORT: "from_utc_date",
				ARRIVAL: "from_utc_date",
				DEPARTURE: "from_utc_date",
			}
		},
		{
			label: "Created Date",
			subLabel: "(UTC)",
			isDefault: true,
			ids: {
				STEAMING: "createdAt",
				PORT: "createdAt",
				ARRIVAL: "createdAt",
				DEPARTURE: "createdAt",
			}
		},
		{
			label: "Report Type",
			isDefault: true,
			ids: {
				STEAMING: "report_type",
				PORT: "report_type",
				ARRIVAL: "report_type",
				DEPARTURE: "report_type",
			}
		},
		{
			label: "Start Time",
			isDefault: true,
			ids: {
				STEAMING: "from_local_time",
				PORT: "from_local_time",
				ARRIVAL: "from_local_time",
				DEPARTURE: "from_local_time",
			}
		},
		{
			label: "End Time",
			isDefault: true,
			ids: {
				STEAMING: "to_local_time",
				PORT: "to_local_time",
				ARRIVAL: "to_local_time",
				DEPARTURE: "to_local_time",
			}
		},
		{
			label: "Status",
			isDefault: true,
			ids: {
				STEAMING: "gi_status",
				PORT: "port_gi_status",
			}
		},
		{
			label: "Condition",
			isDefault: true,
			ids: {
				STEAMING: "gi_condition",
				PORT: "port_gi_condition",
			}
		},
		{
			label: "Elapsed Hrs.",
			isDefault: true,
			ids: {
				STEAMING: "pd_elapsed_hours",
				PORT: "port_elapsed_hours",
				// CARGO: "cargo_elapsed_hours"
			}
		},
		{
			label: "Distance",
			subLabel: "(nm)",
			isDefault: true,
			ids: {
				STEAMING: "pd_log_distance",
				PORT: "port_port_details_observed_distance",
			}
		},
		{
			label: "SOG",
			subLabel: "(knots)",
			isDefault: true,
			ids: {
				STEAMING: "pd_sog",
				PORT: "pd_sog"
			}
		},
		{
			label: "STW",
			subLabel: "(knots)",
			isDefault: true,
			ids: {
				STEAMING: "pd_stw",
				PORT: "pd_stw"
			}
		},
		{
			label: "RPM",
			isDefault: true,
			ids: {
				STEAMING: "me_avg_rpm",
				PORT: "port_me_average_rpm"
			}
		},
		{
			label: "Beaufort",
			isDefault: true,
			ids: {
				STEAMING: "wd_wind_speed",
				PORT: "wd_wind_speed",
			}
		},
		{
			label: "ROBs",
			children: [
				{
					label: "FO",
					subLabel: "(mt)",
					ids: {
						STEAMING: "total_vlsfo_rob",
						PORT: "port_total_vlsfo_rob",
					}
				},
				{
					label: "MGO",
					subLabel: "(mt)",
					ids: {
						STEAMING: "total_mgo_rob",
						PORT: "port_total_mgo_rob",
					}
				},
				{
					label: "LNG",
					subLabel: "(mt)",
					ids: {
						STEAMING: "total_lng_rob",
						PORT: "port_total_lng_rob",
					}
				},
				{
					label: "LPGB",
					subLabel: "(mt)",
					ids: {
						STEAMING: "total_lpgb_rob",
						PORT: "port_total_lpgb_rob",
					}
				},
				{
					label: "LPGP",
					subLabel: "(mt)",
					ids: {
						STEAMING: "total_lpgp_rob",
						PORT: "port_total_lpgp_rob",
					}
				},
				{
					label: "Ethane",
					subLabel: "(mt)",
					ids: {
						STEAMING: "total_ethane_rob",
						PORT: "port_total_ethane_rob",
					}
				},
				{
					label: "BioBlend",
					subLabel: "(mt)",
					ids: {
						STEAMING: "total_bio_blend_rob",
						PORT: "port_total_bio_blend_rob",
					}
				},
				{
					label: "BioLNG",
					subLabel: "(mt)",
					ids: {
						STEAMING: "total_biolng_rob",
						PORT: "port_total_biolng_rob",
					}
				},
			]
		},
		{
			label: "VLSFO",
			fuelType: "VLSFO",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "total_vlsfo_consumed",
						PORT: "port_total_vlsfo_consumed",
					}
				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_vlsfo_lcv",
						PORT: "port_me_vlsfo_lcv",
					}
				},
				{
					label: "Visc. 50C",
					subLabel: "(mm2/s)",
					ids: {
						STEAMING: "me_vlsfo_viscosity",
						PORT: "port_me_vlsfo_viscosity",
					}
				},
			]
		},
		{
			label: "MGO",
			fuelType: "MGO",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_mgo_consumption",
						PORT: "port_me_mgo_consumption",
					}
				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_mgo_lcv",
						PORT: "port_me_mgo_lcv",
					}
				},
				{
					label: "Visc. 50C",
					subLabel: "(mm2/s)",
					ids: {
						STEAMING: "me_mgo_viscosity",
						PORT: "port_me_mgo_viscosity",
					}
				},
			]
		},
		{
			label: "IFO",
			fuelType: "IFO",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_ifo_consumption",
						PORT: "port_me_ifo_consumption",
					}
				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_ifo_lcv",
						PORT: "port_me_ifo_lcv",
					}
				},
				{
					label: "Visc. 50C",
					subLabel: "(mm2/s)",
					ids: {
						STEAMING: "me_ifo_viscosity",
						PORT: "port_me_ifo_viscosity",
					}
				},
			]
		},
		{
			label: "ULSFO",
			fuelType: "ULSFO",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_ulsfo_consumption",
						PORT: "port_me_ulsfo_consumption",
					}
				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_ulsfo_lcv",
						PORT: "port_me_ulsfo_lcv",
					}
				},
				{
					label: "Visc. 50C",
					subLabel: "(mm2/s)",
					ids: {
						STEAMING: "me_ulsfo_viscosity",
						PORT: "port_me_ulsfo_viscosity",
					}
				},
			]
		},
		{
			label: "LNG",
			fuelType: "LNG",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_lng_consumption",
						PORT: "port_me_lng_consumption",
					}

				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_lng_lcv",
						PORT: "port_me_lng_lcv",
					}
				},
			]
		},
		{
			label: "BIO LNG",
			fuelType: "BIOLNG",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_biolng_consumption",
						PORT: "port_me_biolng_consumption",
					}
				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_biolng_lcv",
						PORT: "port_me_biolng_lcv",
					}
				},
				{
					label: "GHG Intensity",
					subLabel: "(gCO2eq/MJ)",
					ids: {
						STEAMING: "me_biolng_ghg_intensity",
						PORT: "port_me_biolng_ghg_intensity",
					}
				},
			]
		},
		{
			label: "LPGB",
			fuelType: "LPGB",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_lpgb_consumption",
						PORT: "port_me_lpgb_consumption",
					}

				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_lpgb_lcv",
						PORT: "port_me_lpgb_lcv",
					}
				},
			]
		},
		{
			label: "LPGP",
			fuelType: "LPGP",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_lpgp_consumption",
						PORT: "port_me_lpgp_consumption",
					}

				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_lpgp_lcv",
						PORT: "port_me_lpgp_lcv",
					}
				},
			]
		},
		{
			label: "Ethanol",
			fuelType: "ETHANOL",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_ethanol_consumption",
						PORT: "port_me_ethanol_consumption",
					}

				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_ethanol_lcv",
						PORT: "port_me_ethanol_lcv",
					}
				},
			]
		},
		{
			label: "Methanol",
			fuelType: "METHANOL",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_methanol_consumption",
						PORT: "port_me_methanol_consumption",
					}

				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_methanol_lcv",
						PORT: "port_me_methanol_lcv",
					}
				},
			]
		},
		{
			label: "Ethane",
			fuelType: "ETHANE",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_ethane_consumption",
						PORT: "port_me_ethane_consumption",
					}

				},
				{
					label: "LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_ethane_lcv",
						PORT: "port_me_ethane_lcv",
					}
				},
			]
		},
		{
			label: "Bio Blend",
			fuelType: "BIO_BLEND",
			children: [
				{
					label: "Cons",
					subLabel: "(tons)",
					ids: {
						STEAMING: "me_bio_blend_consumption",
						PORT: "port_me_bio_blend_consumption",
					}
				},
				{
					label: "Bio Fuel LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_bio_blend_bio_fuel_lcv",
						PORT: "port_me_bio_blend_bio_fuel_lcv",
					}
				},
				{
					label: "Fossil Fuel LCV",
					subLabel: "(KJ/Kg)",
					ids: {
						STEAMING: "me_bio_blend_fossil_fuel_lcv",
						PORT: "port_me_bio_blend_fossil_fuel_lcv",
					}
				},
				{
					label: "Bio Fuel GHG Intensity",
					subLabel: "(gCO2eq/MJ)",
					ids: {
						STEAMING: "me_bio_blend_bio_fuel_ghg_intensity",
						PORT: "port_me_bio_blend_bio_fuel_ghg_intensity",
					}
				},
				{
					label: "Bio Fuel Mass Share",
					subLabel: "(%)",
					ids: {
						STEAMING: "me_bio_blend_bio_fuel_mass_share_percent",
						PORT: "port_me_bio_blend_bio_fuel_mass_share_percent",
					}
				},
				{
					label: "Bio Fuel Type",
					ids: {
						STEAMING: "me_bio_blend_bio_fuel_type",
						PORT: "port_me_bio_blend_bio_fuel_type",
					}
				},
				{
					label: "Fossil Fuel Type",
					ids: {
						STEAMING: "me_bio_blend_fossil_fuel_type",
						PORT: "port_me_bio_blend_fossil_fuel_type",
					}
				},
				{
					label: "Fossil Fuel Visc",
					subLabel: "(mm2/s)",
					ids: {
						STEAMING: "me_bio_blend_fossil_fuel_viscosity",
						PORT: "port_me_bio_blend_fossil_fuel_viscosity",
					}
				},
			]
		},
		{
			label: "Remarks",
			isDefault: true,
			ids: {
				STEAMING: "gi_remarks",
				PORT: "port_gi_remarks",
				ARRIVAL: "arrival_remarks",
				DEPARTURE: "departure_remarks",
			}
		}
	],
	arrivalsDepartures: [
		{
			label: "Created Date",
			subLabel: "(UTC)",
			isDefault: true,
			ids: {
				ARRIVAL: "createdAt",
				DEPARTURE: "createdAt",
			}
		},
		{
			label: "Date & Time",
			subLabel: "(LT)",
			isDefault: true,
			ids: {
				ARRIVAL: "to_local_date",
				DEPARTURE: "to_local_date",
			}
		},
		{
			label: "Report Type",
			isDefault: true,
			ids: {
				ARRIVAL: "report_type",
				DEPARTURE: "report_type",
			}
		},
		{
			label: "Arrived At Port",
			isDefault: true,
			ids: {
				ARRIVAL: "arrival_port",
			}
		},
		{
			label: "Upcoming Port",
			isDefault: true,
			ids: {
				DEPARTURE: "departure_upcoming_ports_port_1",
			}
		},
		{
			label: "Via",
			isDefault: true,
			ids: {
				DEPARTURE: "departure_upcoming_ports_via_1",
			}
		},
		{
			label: "ETA",
			isDefault: true,
			ids: {
				DEPARTURE: "departure_upcoming_ports_eta_1",
			}
		},
		{
			label: "ETA Offset",
			isDefault: true,
			ids: {
				DEPARTURE: "departure_upcoming_ports_eta_offset_1",
			}
		},
		{
			label: "Distance To Go",
			subLabel: "(nm)",
			isDefault: true,
			ids: {
				DEPARTURE: "departure_upcoming_ports_distance_to_go_1",
			}
		},
		{
			label: "Projected Speed",
			subLabel: "(knots)",
			isDefault: true,
			ids: {
				DEPARTURE: "departure_upcoming_ports_projected_speed_1",
			}
		},
		{
			label: "ROBs (Lifted Bunkers)",
			children: [
				{
					label: "VLSFO",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_vlsfo",
						DEPARTURE: "departure_rob_lb_vlsfo",
					}
				},
				{
					label: "MGO",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_mgo",
						DEPARTURE: "departure_rob_lb_mgo",
					}
				},
				{
					label: "IFO",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_ifo",
						DEPARTURE: "departure_rob_lb_ifo",
					}
				},
				{
					label: "ULSFO",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_ulsfo",
						DEPARTURE: "departure_rob_lb_ulsfo",
					}
				},
				{
					label: "LNG",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_lng",
						DEPARTURE: "departure_rob_lb_lng",
					}
				},
				{
					label: "BioLNG",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_biolng",
						DEPARTURE: "departure_rob_lb_biolng",
					}
				},
				{
					label: "LPGB",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_lpgb",
						DEPARTURE: "departure_rob_lb_lpgb",
					}
				},
				{
					label: "LPGP",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_lpgp",
						DEPARTURE: "departure_rob_lb_lpgp",
					}
				},
				{
					label: "Ethane",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_ethane",
						DEPARTURE: "departure_rob_lb_ethane",
					}
				},
				{
					label: "Ethanol",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_ethanol",
						DEPARTURE: "departure_rob_lb_ethanol",
					}
				},
				{
					label: "Methanol",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_methanol",
						DEPARTURE: "departure_rob_lb_methanol",
					}
				},
				{
					label: "BioBlend",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_bio_blend",
						DEPARTURE: "departure_rob_lb_bio_blend",
					}
				},
			]
		},
		{
			label: "ROBs (Departure Bunkers)",
			children: [
				{
					label: "VLSFO",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_vlsfo",
						DEPARTURE: "departure_rob_db_vlsfo",
					}
				},
				{
					label: "MGO",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_mgo",
						DEPARTURE: "departure_rob_db_mgo",
					}
				},
				{
					label: "IFO",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_ifo",
						DEPARTURE: "departure_rob_db_ifo",
					}
				},
				{
					label: "ULSFO",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_ulsfo",
						DEPARTURE: "departure_rob_db_ulsfo",
					}
				},
				{
					label: "LNG",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_lng",
						DEPARTURE: "departure_rob_db_lng",
					}
				},
				{
					label: "BioLNG",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_biolng",
						DEPARTURE: "departure_rob_db_biolng",
					}
				},
				{
					label: "LPGB",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_lpgb",
						DEPARTURE: "departure_rob_db_lpgb",
					}
				},
				{
					label: "LPGP",
					subLabel: "(mt)",
					ids: {
						ARRIVAL: "arrival_rob_lpgp",
						DEPARTURE: "departure_rob_db_lpgp",
					}
				},
			]
		},
		{
			label: "Remarks",
			isDefault: true,
			ids: {
				ARRIVAL: "arrival_remarks",
				DEPARTURE: "departure_remarks",
			}
		}
	],
	sofForms: [
		{
			label: "Selected Date",
			subLabel: "(LT)",
			isDefault: true,
			ids: {
				STATEMENT_OF_FACTS: "selectedDate",
			}
		},
		{
			label: "Created Date",
			subLabel: "(UTC)",
			isDefault: true,
			ids: {
				STATEMENT_OF_FACTS: "createdAt",
			}
		},
		{
			label: "GMT Offset",
			isDefault: true,
			ids: {
				STATEMENT_OF_FACTS: "sof_gmt_offset",
			}
		},
		{
			label: "Port",
			isDefault: true,
			ids: {
				STATEMENT_OF_FACTS: "sof_port",
			}
		},
		{
			label: "End of Sea Passage",
			subLabel: "Date & Time",
			isDefault: true,
			ids: {
				STATEMENT_OF_FACTS: "sof_eosp_date",
				// STATEMENT_OF_FACTS: "sof_eosp_time",
				// STATEMENT_OF_FACTS: "sof_eosp_zd",
			}
		},
		{
			label: "Port ETD",
			subLabel: "Date & Time",
			isDefault: true,
			ids: {
				STATEMENT_OF_FACTS: "sof_port_details_date",
				// STATEMENT_OF_FACTS: "sof_port_details_time",
				// STATEMENT_OF_FACTS: "sof_port_details_zd",
			}
		},
		{
			label: "Statement Of Facts Table",
			isDefault: false,
			ids: {
				STATEMENT_OF_FACTS: "statementOfFactsTable",
			}
		},
		{
			label: "Cargo Handling Table",
			isDefault: false,
			ids: {
				STATEMENT_OF_FACTS: "cargoHandlingTable",
			}
		},
		{
			label: "Remarks",
			isDefault: true,
			ids: {
				STATEMENT_OF_FACTS: "sof_remarks",
			}
		},
	],
	bunker: [
		{
			label: "Selected Date",
			subLabel: "(LT)",
			isDefault: true,
			ids: {
				BUNKER: "selectedDate",
			}
		},
		{
			label: "Created Date",
			subLabel: "(UTC)",
			isDefault: true,
			ids: {
				BUNKER: "createdAt",
			}
		},
		{
			label: "Bunker Delivery Date & Time",
			subLabel: "(Timezone)",
			isDefault: true,
			ids: {
				BUNKER: "bunker_delivery_local_date",
				// BUNKER: "bunker_delivery_local_time",
				// BUNKER: "bunker_delivery_zd",
			}
		},
		{
			label: "VLSFO",
			fuelType: "VLSFO",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "oil_bunkering_vlsfo_actual_mass",
						ALT: "bunker_vlsfo_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "oil_bunkering_vlsfo_bdn_mass",
						ALT: "bunker_vlsfo_mass",
					}
				},
				{
					label: "BDN Grade",
					ids: {
						BUNKER: "oil_bunkering_vlsfo_bdn_grade",
						ALT: "bunker_vlsfo_grade",
					}
				},
				{
					label: "BDN Viscosity",
					ids: {
						BUNKER: "oil_bunkering_vlsfo_bdn_viscosity",
						ALT: "bunker_vlsfo_viscosity",
					}
				},
				{
					label: "Fuel Analysis Grade",
					ids: {
						BUNKER: "oil_bunkering_vlsfo_fuel_analysis_grade",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis Viscosity",
					ids: {
						BUNKER: "oil_bunkering_vlsfo_fuel_analysis_viscosity",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis LCV",
					ids: {
						BUNKER: "oil_bunkering_vlsfo_fuel_analysis_lcv",
						ALT: "bunker_vlsfo_lcv",
					}
				},
			],
		},
		{
			label: "MGO",
			fuelType: "MGO",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "oil_bunkering_mgo_actual_mass",
						ALT: "bunker_mgo_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "oil_bunkering_mgo_bdn_mass",
						ALT: "bunker_mgo_mass",
					}
				},
				{
					label: "BDN Grade",
					ids: {
						BUNKER: "oil_bunkering_mgo_bdn_grade",
						ALT: "bunker_mgo_grade",
					}
				},
				{
					label: "BDN Viscosity",
					ids: {
						BUNKER: "oil_bunkering_mgo_bdn_viscosity",
						ALT: "bunker_mgo_viscosity",
					}
				},
				{
					label: "Fuel Analysis Grade",
					ids: {
						BUNKER: "oil_bunkering_mgo_fuel_analysis_grade",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis Viscosity",
					ids: {
						BUNKER: "oil_bunkering_mgo_fuel_analysis_viscosity",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis LCV",
					ids: {
						BUNKER: "oil_bunkering_mgo_fuel_analysis_lcv",
						ALT: "bunker_mgo_lcv",
					}
				},
			],
		},
		{
			label: "IFO",
			fuelType: "IFO",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "oil_bunkering_ifo_actual_mass",
						ALT: "bunker_ifo_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "oil_bunkering_ifo_bdn_mass",
						ALT: "bunker_ifo_mass",
					}
				},
				{
					label: "BDN Grade",
					ids: {
						BUNKER: "oil_bunkering_ifo_bdn_grade",
						ALT: "bunker_ifo_grade",
					}
				},
				{
					label: "BDN Viscosity",
					ids: {
						BUNKER: "oil_bunkering_ifo_bdn_viscosity",
						ALT: "bunker_ifo_viscosity",
					}
				},
				{
					label: "Fuel Analysis Grade",
					ids: {
						BUNKER: "oil_bunkering_ifo_fuel_analysis_grade",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis Viscosity",
					ids: {
						BUNKER: "oil_bunkering_ifo_fuel_analysis_viscosity",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis LCV",
					ids: {
						BUNKER: "oil_bunkering_ifo_fuel_analysis_lcv",
						ALT: "bunker_ifo_lcv",
					}
				},
			],
		},
		{
			label: "ULSFO",
			fuelType: "ULSFO",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "oil_bunkering_ulsfo_actual_mass",
						ALT: "bunker_ulsfo_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "oil_bunkering_ulsfo_bdn_mass",
						ALT: "bunker_ulsfo_mass",
					}
				},
				{
					label: "BDN Grade",
					ids: {
						BUNKER: "oil_bunkering_ulsfo_bdn_grade",
						ALT: "bunker_ulsfo_grade",
					}
				},
				{
					label: "BDN Viscosity",
					ids: {
						BUNKER: "oil_bunkering_ulsfo_bdn_viscosity",
						ALT: "bunker_ulsfo_viscosity",
					}
				},
				{
					label: "Fuel Analysis Grade",
					ids: {
						BUNKER: "oil_bunkering_ulsfo_fuel_analysis_grade",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis Viscosity",
					ids: {
						BUNKER: "oil_bunkering_ulsfo_fuel_analysis_viscosity",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis LCV",
					ids: {
						BUNKER: "oil_bunkering_ulsfo_fuel_analysis_lcv",
						ALT: "bunker_ulsfo_lcv",
					}
				},
			],
		},
		{
			label: "LNG",
			fuelType: "LNG",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "gas_bunkering_lng_actual_mass",
						ALT: "bunker_lng_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "gas_bunkering_lng_bdn_mass",
						ALT: "",
					}
				},
				{
					label: "BDN LCV",
					ids: {
						BUNKER: "gas_bunkering_lng_bdn_lcv",
						ALT: "bunker_lng_lcv",
					}
				},
			],
		},
		{
			label: "LPGP",
			fuelType: "LPGP",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "gas_bunkering_lpgp_actual_mass",
						ALT: "bunker_lpgp_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "gas_bunkering_lpgp_bdn_mass",
						ALT: "bunker_lpgp_mass",
					}
				},
				{
					label: "BDN LCV",
					ids: {
						BUNKER: "gas_bunkering_lpgp_bdn_lcv",
						ALT: "bunker_lpgp_lcv",
					}
				},
			],
		},
		{
			label: "LPGB",
			fuelType: "LPGB",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "gas_bunkering_lpgb_actual_mass",
						ALT: "bunker_lpgb_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "gas_bunkering_lpgb_bdn_mass",
						ALT: "bunker_lpgb_mass",
					}
				},
				{
					label: "BDN LCV",
					ids: {
						BUNKER: "gas_bunkering_lpgb_bdn_lcv",
						ALT: "bunker_lpgb_lcv",
					}
				},
			],
		},
		{
			label: "LPGMIX",
			fuelType: "LPGMIX",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "gas_bunkering_lpgmix_actual_mass",
						ALT: "bunker_lpgmix_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "gas_bunkering_lpgmix_bdn_mass",
						ALT: "bunker_lpgmix_mass",
					}
				},
				{
					label: "BDN LCV",
					ids: {
						BUNKER: "gas_bunkering_lpgmix_bdn_lcv",
						ALT: "bunker_lpgmix_lcv",
					}
				},
			],
		},
		{
			label: "Ethane",
			fuelType: "ETHANE",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "gas_bunkering_ethane_actual_mass",
						ALT: "bunker_ethane_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "gas_bunkering_ethane_bdn_mass",
						ALT: "bunker_ethane_mass",
					}
				},
				{
					label: "BDN LCV",
					ids: {
						BUNKER: "gas_bunkering_ethane_bdn_lcv",
						ALT: "bunker_ethane_lcv",
					}
				},
			],
		},
		{
			label: "Ethanol",
			fuelType: "ETHANOL",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "alcohol_bunkering_ethanol_actual_mass",
						ALT: "bunker_ethanol_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "alcohol_bunkering_ethanol_bdn_mass",
						ALT: "bunker_ethanol_mass",
					}
				},
				{
					label: "BDN LCV",
					ids: {
						BUNKER: "alcohol_bunkering_ethanol_bdn_lcv",
						ALT: "bunker_ethanol_lcv",
					}
				},
			],
		},
		{
			label: "Methanol",
			fuelType: "METHANOL",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "alcohol_bunkering_methanol_actual_mass",
						ALT: "bunker_methanol_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "alcohol_bunkering_methanol_bdn_mass",
						ALT: "bunker_methanol_mass",
					}
				},
				{
					label: "BDN LCV",
					ids: {
						BUNKER: "alcohol_bunkering_methanol_bdn_lcv",
						ALT: "bunker_methanol_lcv",
					}
				},
			],
		},
		{
			label: "BIOLNG",
			fuelType: "BIOLNG",
			children: [
				{
					label: "Actual Mass",
					ids: {
						BUNKER: "biolng_bunkering_biolng_actual_mass",
						ALT: "bunker_biolng_mass",
					}
				},
				{
					label: "BDN Mass",
					ids: {
						BUNKER: "biolng_bunkering_biolng_bdn_mass",
						ALT: "",
					}
				},
				{
					label: "BDN LCV",
					ids: {
						BUNKER: "biolng_bunkering_biolng_bdn_lcv",
						ALT: "bunker_biolng_lcv",
					}
				},
				{
					label: "POS Documents",
					ids: {
						BUNKER: "biolng_bunkering_biolng_pos_documents_pos_lng",
					}
				},
			],
		},
		// TODO - Add in POS table for V1 reports?
		// {
		// 	label: "Bio Blend Total Mass",
		// 	subLabel: "(tons)",
		// 	fuelType: "BIO_BLEND",
		// 	ids: {
		// 		BUNKER: "bunker_bio_blend_total_mass",
		// 	}
		// },
		// {
		// 	label: "Proof of Sustainability Number",
		// 	isDefault: true,
		// 	ids: {
		// 		BUNKER: "bunker_bio_blend_proof_of_sustainability_number",
		// 	}
		// },
		{
			label: "Bio Blend",
			fuelType: "BIO_BLEND",
			children: [
				{
					label: "Actual Mass",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_actual_mass",
						ALT: "bunker_bio_blend_actual_mass",
					}
				},
				{
					label: "BDN Mass",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_bdn_mass",
						ALT: "",
					}
				},
				{
					label: "BDN Fossil Fuel Type",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_bdn_fossil_fuel_type",
						ALT: "bunker_bio_blend_bio_fuel_fuel_type",
					}
				},
				{
					label: "BDN Fossil Grade",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_bdn_fossil_grade",
						ALT: "",
					}
				},
				{
					label: "BDN Fossil Viscosity",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_bdn_fossil_viscosity",
						ALT: "",
					}
				},
				{
					label: "BDN Fossil Mass",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_bdn_fossil_mass",
						ALT: "",
					}
				},
				{
					label: "BDN Bio Mass",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_bdn_bio_mass",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis Fossil Grade",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_fuel_analysis_fossil_grade",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis Fossil Viscosity",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_fuel_analysis_fossil_viscosity",
						ALT: "",
					}
				},
				{
					label: "Fuel Analysis Fossil LCV",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_fuel_analysis_fossil_lcv",
						ALT: "",
					}
				},
				{
					label: "POS Documents",
					subLabel: "",
					ids: {
						BUNKER: "bio_blend_bunkering_bio_blend_pos_documents_pos_volume",
						// BUNKER: "bio_blend_bunkering_bio_blend_pos_documents_pos_mass",
						ALT: "",
					}
				},
			],
		},
		{
			label: "Remarks",
			isDefault: true,
			ids: {
				BUNKER: "departure_remarks",
			}
		},
	],
	stoppages: [
		{
			label: "Selected Date",
			subLabel: "(LT)",
			isDefault: true,
			ids: {
				DELAY_OFFHIRE_NOTICE: "selectedDate",
			}
		},
		{
			label: "Created Date",
			subLabel: "(UTC)",
			isDefault: true,
			ids: {
				DELAY_OFFHIRE_NOTICE: "createdAt",
			}
		},
		{
			label: "From Date - To Date",
			subLabel: "(Timezone)",
			isDefault: true,
			ids: {
				DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_start_date",
			}
		},
		{
			label: "Delay Duration",
			isDefault: true,
			ids: {
				DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_delay",
			}
		},
		{
			label: "Miles",
			isDefault: true,
			ids: {
				DELAY_OFFHIRE_NOTICE: "delayOffHireNotice_miles",
			}
		},
		{
			label: "Delay Type",
			isDefault: true,
			ids: {
				DELAY_OFFHIRE_NOTICE: "delayOffHireNotice_delay_type",
			}
		},
		{
			label: "Delay Reason",
			isDefault: true,
			ids: {
				DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_reason",
			}
		},
		{
			label: "Fuel Consumption",
			children: [
				{
					label: "VLSFO",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_vlsfo",
					}
				},
				{
					label: "MGO",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_mgo",
					}
				},
				{
					label: "IFO",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_ifo",
					}
				},
				{
					label: "ULSFO",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_ulsfo",
					}
				},
				{
					label: "LNG",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_lng",
					}
				},
				{
					label: "BIOLNG",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_biolng",
					}
				},
				{
					label: "LPGB",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_lpgb",
					}
				},
				{
					label: "LPGP",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_lpgp",
					}
				},
				{
					label: "Ethanol",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_ethanol",
					}
				},
				{
					label: "Methanol",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_methanol",
					}
				},
				{
					label: "Ethane",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_ethane",
					}
				},
				{
					label: "Bio Blend",
					ids: {
						DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_fc_bio_blend",
					}
				},
			]
		},
		{
			label: "Remarks",
			isDefault: true,
			ids: {
				DELAY_OFFHIRE_NOTICE: "delayOffhireNotice_remarks",
			}
		}
	],
	cargo: [
		// {
		// 	label: "From Date - To Date",
		// 	subLabel: "(UTC)",
		// 	isDefault: true,
		// 	ids: {
		// 		CARGO: "from_utc_date",
		// 	}
		// },
		// {
		// 	label: "Cargo Type",
		// 	isDefault: true,
		// 	ids: {
		// 		CARGO: "",
		// 	}
		// },
		// {
		// 	label: "Master",
		// 	isDefault: true,
		// 	ids: {
		// 		CARGO: "",
		// 	}
		// },
		// {
		// 	label: "Ch. Engineer",
		// 	subLabel: "Signed On",
		// 	isDefault: true,
		// 	ids: {
		// 		CARGO: "",
		// 	}
		// },
		// {
		// 	label: "Submitted By",
		// 	subLabel: "Signed On",
		// 	isDefault: true,
		// 	ids: {
		// 		CARGO: "",
		// 	}
		// },
		// {
		// 	label: "Updated By",
		// 	subLabel: "Signed On",
		// 	isDefault: true,
		// 	ids: {
		// 		CARGO: "",
		// 	}
		// },
		{
			label: "Created Date",
			subLabel: "(UTC)",
			isDefault: true,
			ids: {
				CARGO: "createdAt",
			}
		},
		{
			label: "All Fast - Cast Off",
			subLabel: "(Local)",
			isDefault: true,
			ids: {
				CARGO: "from_all_fast_local_date",
				// CARGO: "from_all_fast_zd",
				// CARGO: "to_cast_off_local_date",
				// CARGO: "to_cast_off_zd",
			}
		},
		{
			label: "Elapsed Hrs.",
			subLabel: "",
			isDefault: true,
			ids: {
				CARGO: "cargo_elapsed_hours",
			}
		},
		{
			label: "Operation Details",
			isDefault: true,
			children: [
				{
					label: "Total Qty. Onboard",
					subLabel: "(on Cast Off [mt])",
					ids: {
						CARGO: "cargo_total_quantity_onboard_cast_off",
					}
				},
				{
					label: "STS",
					ids: {
						CARGO: "cargo_sts",
					}
				},
				{
					label: "Out Side Port Limits",
					ids: {
						CARGO: "cargo_opl_outside_port_limits",
					}
				},
			],
		},
		{
			label: "Tanker Cargo",
			ids: {
				CARGO: "cargo_cargo_table"
			},
			children: [
				{
					label: "Cargo Type",
					ids: {
						CARGO: "cargo_cargo_type",
					}
				},
				{
					label: "Qty. Loaded",
					ids: {
						CARGO: "cargo_quantity_loaded",
					}
				},
				{
					label: "Quantity Discharged",
					ids: {
						CARGO: "cargo_quantity_discharged",
					}
				},
				{
					label: "Density",
					subLabel: "(kg/m3)",
					ids: {
						CARGO: "cargo_density",
					}
				},
				{
					label: "Temperature",
					subLabel: "(C)",
					ids: {
						CARGO: "cargo_temperature",
					}
				},
				{
					label: "Commencement",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "commencement_date",
					}
				},
				{
					label: "Completion",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "completion_date",
					}
				},
			],
			subType: "TANKER",
			isDefault: true,
		},
		{
			label: "Gas Cargo",
			ids: {
				CARGO: "cargo_cargo_table"
			},
			children: [
				{
					label: "Cargo Type",
					ids: {
						CARGO: "cargo_cargo_type",
					}
				},
				{
					label: "Qty. Loaded",
					ids: {
						CARGO: "cargo_quantity_loaded",
					}
				},
				{
					label: "Quantity Discharged",
					ids: {
						CARGO: "cargo_quantity_discharged",
					}
				},
				{
					label: "Density",
					subLabel: "(kg/m3)",
					ids: {
						CARGO: "cargo_density",
					}
				},
				{
					label: "Temperature",
					subLabel: "(C)",
					ids: {
						CARGO: "cargo_temperature",
					}
				},
				{
					label: "Commencement",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "commencement_date",
					}
				},
				{
					label: "Completion",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "completion_date",
					}
				},
			],
			subType: "LNG",
			isDefault: true,
		},
		{
			label: "Bulk Cargo",
			ids: {
				CARGO: "cargo_cargo_table",
			},
			children: [
				{
					label: "Cargo Type",
					ids: {
						CARGO: "cargo_cargo_type",
					}
				},
				{
					label: "Qty. Loaded",
					ids: {
						CARGO: "cargo_quantity_loaded",
					}
				},
				{
					label: "Quantity Discharged",
					ids: {
						CARGO: "cargo_quantity_discharged",
					}
				},
				{
					label: "Commencement",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "commencement_date",
					}
				},
				{
					label: "Completion",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "completion_date",
					}
				},
			],
			subType: "BULK",
			isDefault: true,
		},
		{
			label: "Loaded Containers",
			ids: {
				CARGO: "cargo_loaded_containers_table",
			},
			children: [
				{
					label: "Size",
					subLabel: "(ft)",
					ids: {
						CARGO: "size",
					}
				},
				{
					label: "Units",
					ids: {
						CARGO: "units",
					}
				},
				{
					label: "IMDG",
					ids: {
						CARGO: "imdg",
					}
				},
				{
					label: "Reefers",
					ids: {
						CARGO: "reefers",
					}
				},
				{
					label: "Total Weight",
					subLabel: "(mt)",
					ids: {
						CARGO: "total_weight",
					}
				},
				{
					label: "Commencement",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "commencement_date",
					}
				},
				{
					label: "Completion",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "completion_date",
					}
				},
			],
			subType: "CONTAINER",
			isDefault: true,
		},
		{
			label: "Discharge Containers",
			ids: {
				CARGO: "cargo_discharged_containers_table",
			},
			children: [
				{
					label: "Size",
					subLabel: "(ft)",
					ids: {
						CARGO: "size",
					}
				},
				{
					label: "Units",
					ids: {
						CARGO: "units",
					}
				},
				{
					label: "IMDG",
					ids: {
						CARGO: "imdg",
					}
				},
				{
					label: "Reefers",
					ids: {
						CARGO: "reefers",
					}
				},
				{
					label: "Total Weight",
					subLabel: "(mt)",
					ids: {
						CARGO: "total_weight",
					}
				},
				{
					label: "Commencement",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "commencement_date",
					}
				},
				{
					label: "Completion",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "completion_date",
					}
				},
			],
			subType: "CONTAINER",
			isDefault: true,
		},
		{
			label: "Break Bulk Cargo",
			children: [
				{
					label: "Loaded",
					subLabel: "(mt)",
					ids: {
						CARGO: "cargo_break_bulk_loaded",
					}
				},
				{
					label: "Discharge",
					subLabel: "(mt)",
					ids: {
						CARGO: "cargo_break_bulk_discharged",
					}
				},
			],
			subType: "CONTAINER",
			isDefault: true,
		},
		{
			label: "PCTC Cargo",
			ids: {
				CARGO: "cargo_info_table"
			},
			children: [
				{
					label: "Type",
					ids: {
						CARGO: "type",
					}
				},
				{
					label: "No. of Vehicles Loaded",
					ids: {
						CARGO: "no_of_vehicles_loaded",
					}
				},
				{
					label: "No. of Vehicles Discharged",
					ids: {
						CARGO: "no_of_vehicles_discharged",
					}
				},
				{
					label: "Commencement",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "commencement_date",
					}
				},
				{
					label: "Completion",
					subLabel: "(Date and Time)",
					ids: {
						CARGO: "completion_date",
					}
				},
			],
			subType: "PCTC",
			isDefault: true,
		},
		{
			label: "VLSFO ROB",
			fuelType: "VLSFO",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_vlsfo",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_vlsfo",
					}
				},
			]
		},
		{
			label: "MGO ROB",
			fuelType: "MGO",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_mgo",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_mgo",
					}
				},
			]
		},
		{
			label: "IFO ROB",
			fuelType: "IFO",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_ifo",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_ifo",
					}
				},
			]
		},
		{
			label: "ULSFO ROB",
			fuelType: "ULSFO",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_ulsfo",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_ulsfo",
					}
				},
			]
		},
		{
			label: "LNG ROB",
			fuelType: "LNG",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_lng",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_lng",
					}
				},
			]
		},
		{
			label: "BIO LNG ROB",
			fuelType: "BIOLNG",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_biolng",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_biolng",
					}
				},
			]
		},
		{
			label: "LPGB ROB",
			fuelType: "LPGB",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_lpgb",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_lpgb",
					}
				},
			]
		},
		{
			label: "LPGP ROB",
			fuelType: "LPGP",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_lpgp",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_lpgp",
					}
				},
			]
		},
		{
			label: "Ethanol ROB",
			fuelType: "ETHANOL",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_ethanol",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_ethanol",
					}
				},
			]
		},
		{
			label: "Methanol ROB",
			fuelType: "METHANOL",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_methanol",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_methanol",
					}
				},
			]
		},
		{
			label: "Ethane ROB",
			fuelType: "ETHANE",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_ethane",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_ethane",
					}
				},
			]
		},
		{
			label: "BIO BLEND ROB",
			fuelType: "BIO_BLEND",
			children: [
				{
					label: "ALL FAST",
					ids: {
						CARGO: "cargo_rob_all_fast_bio_blend",
					}
				},
				{
					label: "CAST OFF",
					ids: {
						CARGO: "cargo_rob_cast_off_bio_blend",
					}
				},
			]
		},
		{
			label: "Remarks",
			isDefault: true,
			ids: {
				CARGO: "cargo_remarks",
			}
		},
	]
}

export default vesselOnboardConstants;
